import { Box, useTheme, Typography, Button } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../global/theme/tokens';
import ExoAvatar from '../../components/exo/ExoAvatar';
import CategoryIcon from '@mui/icons-material/Category';

export const SalesObjectGridItem = ({ item }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const { ownerType, owner, id, image, title, nr } = item;

  const nameMap = {
    companyLead: owner?.nameShort || owner?.name,
    personLead: `${owner?.salutation} ${owner?.lastName} ${owner?.firstName}`,
    company: owner?.nameShort || owner?.name,
    contact: `${owner?.salutation} ${owner?.lastName} ${owner?.firstName}`,
    internal: t('internal'),
  };

  const name = ownerType ? nameMap[ownerType] : t('internal');

  return (
    <NavLink to={`/sales-objects/${id}`}>
      <Button
        variant="contained"
        color="secondary"
        sx={{
          transition: 'scale 0.3s ease',
          padding: '5px',
        }}
        className=" cursor-pointer w-full flex flex-col backdrop-blur-lg items-center rounded-lg"
      >
        {image ? (
          <img
            src={image.temporaryUrl}
            className="h-32 rounded-[5px] max-w-full object-cover"
          />
        ) : (
          <ExoAvatar
            picture={owner?.logo && owner.logo.temporaryUrl}
            type={ownerType}
            name={name}
            icon={<CategoryIcon sx={{ fontSize: '55px' }} />}
            size="128px"
          />
        )}
        <Typography variant="h5" className="pt-4">
          <b>{title}</b>
        </Typography>
        <Typography variant="h6">{name}</Typography>
        <Typography
          variant="h5"
          className="pt-1 monospace w-full"
          textAlign="right"
        >
          {nr}
        </Typography>
      </Button>
    </NavLink>
  );
};
